module.exports = __webpack_public_path__ + "img/novotag_1.4cc25ab5.jpg";